export class RegistrationValidationError extends Error {
  constructor() {
    super('Please verify your details are correct.')
    Object.setPrototypeOf(this, RegistrationValidationError.prototype)
  }
}
